import { PersistentStorageService } from './interfaces';

export class PersistentStorageServerService implements PersistentStorageService {
  load() {
    return {};
  }

  save() {}
}
